import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  public forgotLoginForm:FormGroup;

  public isMessageShow:boolean = false;

  public message:string = "";
  
  constructor(private fb:FormBuilder,
    private authenticationService:AuthenticationService) { }

  ngOnInit(): void {

    this.createForgotLoginForm();
  }
  
  createForgotLoginForm():void{
    this.forgotLoginForm = this.fb.group({
        'email': ['',[Validators.required,Validators.email]]
    });
  }

  get forgotLoginFormValidate(){ return this.forgotLoginForm.controls; }

  forgotLoginFormSubmit():void{

    if(!this.forgotLoginForm.valid){
      return;
    }

    // console.log(this.forgotLoginForm.value);
    this.authenticationService.forgotPassword(this.forgotLoginForm.value).subscribe(
      (res) =>{
        if(res.status == 'success'){
          this.message = res.message;
          this.isMessageShow = true;  
        }

        if(res.status == 'error'){
          Swal.fire({
            icon: res.status,
            text: res.message
          })
        }
      },
      (err)=> {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong! Please try again later.',
        });
      }
    )
  }

}
